import { OfferingType, } from '../offerings/offering.dto';
var DurationDtoFactory = /** @class */ (function () {
    function DurationDtoFactory() {
    }
    DurationDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            startDate: offeringDto.schedule.startDate,
            durationInMinutes: DurationDtoFactory.durationInMinutesFromOffering(offeringDto),
            isDurationVaries: DurationDtoFactory.isDurationVariesFromOffering(offeringDto),
        };
    };
    DurationDtoFactory.durationInMinutesFromOffering = function (offeringDto) {
        if (offeringDto.type === OfferingType.INDIVIDUAL ||
            offeringDto.type === OfferingType.DUMMY ||
            offeringDto.type === OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.durationInMinutes;
        }
        return 0;
    };
    DurationDtoFactory.isDurationVariesFromOffering = function (offeringDto) {
        if (offeringDto.type === OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.isDurationVaries;
        }
        return false;
    };
    return DurationDtoFactory;
}());
export { DurationDtoFactory };
//# sourceMappingURL=duration-dto-factory.js.map